import {
  Bell,
  ChevronDown,
  Search,
  UserRound,
  Settings,
  LogOut,
} from "lucide-react";
import { useState, useRef, useEffect } from "react";

export default function VendorTopbar({ collapsed }) {
  const [showNotifications, setShowNotifications] = useState(false);
  const [vendor, setVendor] = useState(null);
  const [showProfile, setShowProfile] = useState(false);

  const notifRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    fetch("/api/vendor/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setVendor(data.vendor);
        } else {
          window.location.href = "/vendorlogin";
        }
      })
      .catch(() => {
        window.location.href = "/vendorlogin";
      });
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <header
      className={`
        fixed top-0 right-0 z-30 h-20
        ${collapsed ? "left-20" : "left-72"}
        px-10
        flex items-center justify-between
        border-b border-white/10
        bg-gradient-to-b from-black/60 to-black/30
        backdrop-blur-xl
        transition-all duration-300
      `}
    >
      {/* LEFT */}
      <div className="flex items-center gap-8">
        <div>
          <h1 className="text-xl font-serif tracking-wide">Vendor Dashboard</h1>
          <p className="text-xs text-gray-400">Orders • Invoices • Payments</p>
        </div>

        {/* SEARCH */}
        <div
          className="hidden lg:flex items-center gap-2 px-4 py-2 rounded-xl
          bg-black/40 border border-white/10"
        >
          <Search size={16} className="text-gray-400" />
          <input
            placeholder="Search orders, invoices..."
            className="bg-transparent text-sm outline-none placeholder-gray-500 w-56"
          />
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-6">
        {/* ===== NOTIFICATIONS ===== */}
        <div className="relative" ref={notifRef}>
          <button
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowProfile(false);
            }}
            className="relative p-2 rounded-xl hover:bg-white/10 transition"
          >
            <Bell size={20} />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-amber-400 rounded-full" />
          </button>

          {showNotifications && (
            <div
              className="absolute right-0 mt-3 w-80 rounded-2xl
              bg-[#0b0b0f] border border-white/10 shadow-xl overflow-hidden"
            >
              <div className="px-5 py-3 border-b border-white/10">
                <p className="font-medium">Notifications</p>
              </div>

              <ul className="divide-y divide-white/10 text-sm">
                <li className="px-5 py-3 hover:bg-white/5 cursor-pointer">
                  📦 New purchase order received
                </li>
                <li className="px-5 py-3 hover:bg-white/5 cursor-pointer">
                  🧾 Invoice approved
                </li>
                <li className="px-5 py-3 hover:bg-white/5 cursor-pointer">
                  💰 Payment processed
                </li>
              </ul>

              <div className="px-5 py-3 text-center text-xs text-amber-400 cursor-pointer hover:bg-white/5">
                View all notifications
              </div>
            </div>
          )}
        </div>

        {/* ===== PROFILE ===== */}
        <div className="relative" ref={profileRef}>
          <div
            onClick={() => {
              setShowProfile(!showProfile);
              setShowNotifications(false);
            }}
            className="flex items-center gap-3 px-4 py-2 rounded-xl
            bg-black/40 border border-white/10 cursor-pointer hover:bg-white/5 transition"
          >
            <UserRound size={18} className="text-amber-400" />
            <div className="text-right leading-tight">
              <p className="text-sm font-medium">{vendor?.name || "..."}</p>
              <p className="text-xs text-gray-400">Vendor</p>
            </div>
            <ChevronDown size={16} />
          </div>

          {showProfile && (
            <div
              className="absolute right-0 mt-3 w-56 rounded-2xl
              bg-[#0b0b0f] border border-white/10 shadow-xl overflow-hidden"
            >
              <div className="px-5 py-4 border-b border-white/10">
                <p className="font-medium">{vendor?.name}</p>
                <p className="text-xs text-gray-400">{vendor?.email}</p>
              </div>

              <button
                className="w-full flex items-center gap-3 px-5 py-3
                hover:bg-white/5 transition text-sm"
              >
                <Settings size={16} />
                Account Settings
              </button>

              <button
                onClick={async () => {
                  await fetch("/api/vendor/logout", {
                    method: "POST",
                    credentials: "include",
                  });

                  window.location.href = "/vendorlogin";
                }}
                className="w-full flex items-center gap-3 px-5 py-3
                hover:bg-red-500/10 text-red-400 transition text-sm"
              >
                <LogOut size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
